import { useState } from "react";
import { Button } from "primereact/button";

import S from "../_styles.module.scss";
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

const CodeBlock = ({ node, children }) => {
  const [codeCopied, setCodeCopied] = useState(false);

  const codeChunk = node.children[0].children[0].value;
  const handleCopyCode = codeChunk => {
    setCodeCopied(true);
    navigator.clipboard.writeText(codeChunk);
    setTimeout(() => {
      setCodeCopied(false);
    }, 3000);
  };
  return (
    <div className={C(S.instructionCodeBlock, T.bgElevation1)}>
      <div className="flex justify-end self-stretch items-start">
        <Button
          label="Copy"
          icon={codeCopied ? "pi pi-file-check" : "pi pi-copy"}
          iconPos="right"
          size="small"
          text
          onClick={() => handleCopyCode(codeChunk)}
        />
      </div>
      <pre className={T.scrollbar}>{children}</pre>
    </div>
  );
};

export default CodeBlock;
